module.exports = __webpack_public_path__ + "img/2021_dande_kumamotojo_0928_fin_web.47f8c992.png";